<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import ActionLogsTable from "@/components/Dashboard/Devices/AppActionLogs/ActionLogsTable.vue";
import FilterActionLogs from "@/components/Dashboard/Devices/AppActionLogs/FilterActionLogs.vue";
import LatestActionLogs from "@/components/Dashboard/Devices/AppActionLogs/LatestActionLogs.vue";
</script>
<template>
  <ContentHeader :name="'App Action Logs'" />

  <section class="content">
    <div class="container-fluid">
      <div class="row tablet-column">
        <FilterActionLogs />
        <LatestActionLogs />
      </div>
    </div>
  </section>

  <ActionLogsTable />
</template>

<style scoped>
@media (max-width: 1024px) {
  .tablet-column {
    flex-direction: column;
  }

  .filter-column {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
